export default __webpack_public_path__ + "static/media/growth.4bfd93b5.gif";